'use client'
import {MIXPANEL_ATTRIBUTES, MIXPANEL_KEYS} from 'analytics/mixpanel'
import TermsOfService from 'components/documents/terms-of-service'
import {useTrackEvent} from 'hooks/use-track-event'
import {Suspense} from 'react'

const page2 = () => {
  return (
    <Suspense>
      <Page />
    </Suspense>
  )
}

const Page = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useTrackEvent(MIXPANEL_KEYS.TERMS_OF_SERVICE, [MIXPANEL_ATTRIBUTES.SOURCE])
  return <TermsOfService />
}

export default page2
